import React from "react";
import { Linkedin, Github, Twitter } from "lucide-react";

const team = [
  { img: "img/team/01.jpg", name: "Sandeep", role: "Director & Founder", tag: "Strategy · Delivery" },
  { img: "img/team/02.jpg", name: "Full-Stack Developer", role: "Web Engineering", tag: ".NET · Angular · React" },
  { img: "img/team/03.jpg", name: "Mobile App Developer", role: "App Engineering", tag: "React Native" },
  { img: "img/team/04.jpg", name: "Database & DevOps", role: "Data & Deployment", tag: "SQL · Postgres · Hosting" },
  { img: "img/team/05.jpeg", name: "Amandeep", role: "Website Designer", tag: "UI · Web Design" },
];

export const Team = () => {
  return (
    <section id="team" className="relative bg-[#05070f] py-24 overflow-hidden">
      <div className="absolute top-1/4 left-1/3 w-[440px] h-[440px] rounded-full bg-blue-700/10 blur-[130px]" />
      <div className="relative max-w-6xl mx-auto px-4">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <span className="eyebrow reveal">The People</span>
          <h2 className="reveal d1 mt-5 font-display text-white text-3xl md:text-5xl">
            Meet the <span className="text-gradient">team</span>
          </h2>
          <p className="reveal d2 mt-4 text-slate-400 text-base md:text-lg">
            A compact, senior team that owns your product end-to-end — from
            architecture to deployment.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {team.map((m, i) => (
            <div
              key={m.name + i}
              className={`reveal d${(i % 4) + 1} glow-card group rounded-3xl p-6 glass hover:-translate-y-1.5 transition-all duration-300 text-center`}
            >
              <div className="relative mx-auto w-28 h-28 mb-5">
                <div className="absolute inset-0 rounded-full bg-gradient-to-br from-blue-500 to-violet-500 blur-md opacity-60 group-hover:opacity-90 transition" />
                <img
                  src={m.img}
                  alt={m.name}
                  loading="lazy"
                  className="relative w-28 h-28 rounded-full object-cover border-2 border-white/20"
                />
              </div>

              <h3 className="text-white font-extrabold text-lg">{m.name}</h3>
              <p className="text-blue-400 font-bold text-sm mt-0.5">{m.role}</p>
              <p className="text-slate-500 text-xs font-semibold mt-1">{m.tag}</p>

              <div className="mt-4 flex items-center justify-center gap-2 opacity-70 group-hover:opacity-100 transition">
                {[Linkedin, Github, Twitter].map((Icon, k) => (
                  <span key={k} className="h-8 w-8 rounded-lg grid place-items-center bg-white/5 border border-white/10 text-slate-300 hover:text-white hover:bg-white/10 transition">
                    <Icon className="h-4 w-4" />
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
